var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.453 14.004v-2.97c0-.9-.322-1.763-.894-2.4-.573-.636-1.35-.993-2.16-.993H3.054c-.81 0-1.587.357-2.16.994-.572.636-.894 1.5-.894 2.4v2.969M5.727 6.363a3.181 3.181 0 1 0 0-6.363 3.181 3.181 0 0 0 0 6.363"
  })));
};
export default SvgPerson;